// extracted by mini-css-extract-plugin
export default {"table_container":"style_table_container__sh3eq"};